// extracted by mini-css-extract-plugin
export default {"switcher-popover-avatar-box":"x4QbfJRgQEC0DtZ4wNKU","switcher-popover-avatar-img":"Uo1qVMLOsogHZMa9HvWc"};